// extracted by mini-css-extract-plugin
module.exports = {"borderArea":"Xxql9","borderAreaHover":"xedmF"};